import React from 'react'
import PropTypes from 'prop-types'

import useStyles from './styles';
import clsx from "clsx";

function WidgetBody(props) {

  const classes = useStyles();

  return (
    <div className={clsx(classes.container, props.classes)} style={props.style || {}}>
      {props.children}
    </div>
  )
}

WidgetBody.propTypes = {

}

export default WidgetBody

